import React from 'react';
import { useForm } from 'react-hook-form';
import { ChatContainerBaseConfig } from '../../base';
import { ThreadOptionContainerProps } from './threadOptionProps';
import { ThreadOptionController } from './threadOptionInterface';
import { ThreadOptionFormValues } from './threadOptionModel';

export function createThreadOptionContainer(
    config: ChatContainerBaseConfig,
    controller: ThreadOptionController
): React.FC<ThreadOptionContainerProps> {
    const {
        context: { useContext },
        state: states,
    } = config;

    return states.composer.subscribe(
        ({ as: View, ...containerProps }: ThreadOptionContainerProps) => {
            const context = useContext();
            const state = states.composer.useState(context);

            const form = useForm<ThreadOptionFormValues>({
                defaultValues: {
                    version: state.value.version || 'active',
                },
            });

            // Watch for form changes and update global state
            const currentValues = form.watch();
            React.useEffect(() => {
                if (currentValues.version !== state.value.version) {
                    state.onChange({
                        version: currentValues.version,
                    });
                }
            }, [currentValues.version, state]);

            const props = controller.useProps(context, {
                form: {
                    id: 'thread-option',
                    form: form,
                    onSubmit(values) {
                        console.log('thread option form', values);
                        state.onChange({
                            version: values.version,
                        });
                        containerProps.onSubmit?.(values);
                        containerProps.onClose?.();
                    },
                },
                values: currentValues,
            });
            return <View {...props} />;
        }
    );
}
